"use strict";
/** @module models */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SCUEventDeviceConnectionLost = exports.SCUEventPrintingFailure = exports.SCUEventLowDiskSpace = exports.SCUEventTtsFailure = exports.SCUEventAudioRecorderFailure = exports.SCUEventHueAuthFailure = exports.SCUEventTimeOutOfSync = exports.SCUEventAudioFailure = exports.SCUEventGenericError = exports.SCUEventDeviceConnectionRestored = exports.SCUEventDeviceType = exports.SCUEventNetworkDown = exports.SCUEventNetworkUp = exports.SCUEventBackupNetwork = exports.SCUEventPrimaryNetwork = exports.SCUEventBooted = exports.SCUEventGenericInfo = exports.SCUEventPrint = exports.SCUEventGPIO = exports.SCUEventTts = exports.SCUEventTone = exports.SCUEventLight = exports.SCUEventDispatch = exports.SCUEventDispatchUnit = exports.SCUEventDispatchAckType = exports.SCUEventDispatchJob = exports.SCUEvent = exports.SCUNetworkType = exports.SCULogLevel = exports.SCUEventType = void 0;
var cerealParse_1 = require("../cerealParse");
var SCUEventType;
(function (SCUEventType) {
    SCUEventType[SCUEventType["dispatch"] = 0] = "dispatch";
    SCUEventType[SCUEventType["light"] = 1] = "light";
    SCUEventType[SCUEventType["tone"] = 2] = "tone";
    SCUEventType[SCUEventType["tts"] = 3] = "tts";
    SCUEventType[SCUEventType["gpio"] = 4] = "gpio";
    SCUEventType[SCUEventType["print"] = 5] = "print";
    SCUEventType[SCUEventType["genericInfo"] = 6] = "genericInfo";
    SCUEventType[SCUEventType["booted"] = 7] = "booted";
    SCUEventType[SCUEventType["backupNetwork"] = 8] = "backupNetwork";
    SCUEventType[SCUEventType["primaryNetwork"] = 9] = "primaryNetwork";
    SCUEventType[SCUEventType["networkUp"] = 10] = "networkUp";
    SCUEventType[SCUEventType["networkDown"] = 11] = "networkDown";
    SCUEventType[SCUEventType["deviceConnectionRestored"] = 12] = "deviceConnectionRestored";
    SCUEventType[SCUEventType["genericError"] = 13] = "genericError";
    SCUEventType[SCUEventType["audioFailure"] = 14] = "audioFailure";
    SCUEventType[SCUEventType["timeOutOfSync"] = 15] = "timeOutOfSync";
    SCUEventType[SCUEventType["lowDiskSpace"] = 16] = "lowDiskSpace";
    SCUEventType[SCUEventType["printingFailure"] = 17] = "printingFailure";
    SCUEventType[SCUEventType["deviceConnectionLost"] = 18] = "deviceConnectionLost";
    SCUEventType[SCUEventType["hueAuthFailure"] = 19] = "hueAuthFailure";
    SCUEventType[SCUEventType["audioRecorderFailure"] = 20] = "audioRecorderFailure";
    SCUEventType[SCUEventType["ttsFailure"] = 21] = "ttsFailure";
})(SCUEventType = exports.SCUEventType || (exports.SCUEventType = {}));
var SCULogLevel;
(function (SCULogLevel) {
    SCULogLevel[SCULogLevel["action"] = 0] = "action";
    SCULogLevel[SCULogLevel["info"] = 1] = "info";
    SCULogLevel[SCULogLevel["error"] = 2] = "error";
})(SCULogLevel = exports.SCULogLevel || (exports.SCULogLevel = {}));
var SCUNetworkType;
(function (SCUNetworkType) {
    SCUNetworkType[SCUNetworkType["primary"] = 0] = "primary";
    SCUNetworkType[SCUNetworkType["backup"] = 1] = "backup";
})(SCUNetworkType = exports.SCUNetworkType || (exports.SCUNetworkType = {}));
var SCUEvent = /** @class */ (function () {
    function SCUEvent(id, scuId, ts, level, type) {
        this.id = id;
        this.scuId = scuId;
        this.ts = ts;
        this.level = level;
        this.type = type;
    }
    SCUEvent.parse = function (o) {
        try {
            var id = cerealParse_1.ParseUtils.getString(o, 'id');
            var scuId = cerealParse_1.ParseUtils.getString(o, 'scuId');
            var type = cerealParse_1.ParseUtils.getEnum(o, 'type', SCUEventType);
            var ts = cerealParse_1.ParseUtils.getUNIXTimestampDate(o, 'ts');
            var level = cerealParse_1.ParseUtils.getEnum(o, 'level', SCULogLevel);
            switch (type) {
                case SCUEventType.dispatch:
                    return SCUEventDispatch.parseEvent(id, scuId, ts, level, o);
                case SCUEventType.light:
                    return SCUEventLight.parseEvent(id, scuId, ts, level, o);
                case SCUEventType.tone:
                    return SCUEventTone.parseEvent(id, scuId, ts, level, o);
                case SCUEventType.tts:
                    return SCUEventTts.parseEvent(id, scuId, ts, level, o);
                case SCUEventType.gpio:
                    return SCUEventGPIO.parseEvent(id, scuId, ts, level, o);
                case SCUEventType.print:
                    return SCUEventPrint.parseEvent(id, scuId, ts, level, o);
                case SCUEventType.genericInfo:
                    return SCUEventGenericInfo.parseEvent(id, scuId, ts, level, o);
                case SCUEventType.booted:
                    return SCUEventBooted.parseEvent(id, scuId, ts, level);
                case SCUEventType.primaryNetwork:
                    return SCUEventPrimaryNetwork.parseEvent(id, scuId, ts, level);
                case SCUEventType.backupNetwork:
                    return SCUEventBackupNetwork.parseEvent(id, scuId, ts, level);
                case SCUEventType.networkUp:
                    return SCUEventNetworkUp.parseEvent(id, scuId, ts, level, o);
                case SCUEventType.networkDown:
                    return SCUEventNetworkDown.parseEvent(id, scuId, ts, level, o);
                case SCUEventType.deviceConnectionRestored:
                    return SCUEventDeviceConnectionRestored.parseEvent(id, scuId, ts, level, o);
                case SCUEventType.genericError:
                    return SCUEventGenericError.parseEvent(id, scuId, ts, level, o);
                case SCUEventType.audioFailure:
                    return SCUEventAudioFailure.parseEvent(id, scuId, ts, level, o);
                case SCUEventType.timeOutOfSync:
                    return SCUEventTimeOutOfSync.parseEvent(id, scuId, ts, level);
                case SCUEventType.lowDiskSpace:
                    return SCUEventLowDiskSpace.parseEvent(id, scuId, ts, level, o);
                case SCUEventType.printingFailure:
                    return SCUEventPrintingFailure.parseEvent(id, scuId, ts, level, o);
                case SCUEventType.deviceConnectionLost:
                    return SCUEventDeviceConnectionLost.parseEvent(id, scuId, ts, level, o);
                case SCUEventType.hueAuthFailure:
                    return SCUEventHueAuthFailure.parseEvent(id, scuId, ts, level, o);
                case SCUEventType.audioRecorderFailure:
                    return SCUEventAudioRecorderFailure.parseEvent(id, scuId, ts, level, o);
                case SCUEventType.ttsFailure:
                    return SCUEventTtsFailure.parseEvent(id, scuId, ts, level, o);
                default:
                    return cerealParse_1.ParseUtils.parseFailure("Invalid SCUEvent Model: Bad Type " + SCUEventType[type]);
            }
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid SCUEvent Model: " + e.message);
        }
    };
    return SCUEvent;
}());
exports.SCUEvent = SCUEvent;
var SCUEventDispatchJob = /** @class */ (function () {
    function SCUEventDispatchJob(id, incidentId, locationOfIncident, ts) {
        this.id = id;
        this.incidentId = incidentId;
        this.locationOfIncident = locationOfIncident;
        this.ts = ts;
    }
    SCUEventDispatchJob.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new SCUEventDispatchJob(cerealParse_1.ParseUtils.getString(o, 'id'), cerealParse_1.ParseUtils.getStringOrNull(o, 'incidentId'), cerealParse_1.ParseUtils.getString(o, 'locationOfIncident'), cerealParse_1.ParseUtils.getUNIXTimestampDate(o, 'ts')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid SCUEventDispatchJob model " + e.message);
        }
    };
    return SCUEventDispatchJob;
}());
exports.SCUEventDispatchJob = SCUEventDispatchJob;
var SCUEventDispatchAckType;
(function (SCUEventDispatchAckType) {
    SCUEventDispatchAckType[SCUEventDispatchAckType["pending"] = 0] = "pending";
    SCUEventDispatchAckType[SCUEventDispatchAckType["ack"] = 1] = "ack";
    SCUEventDispatchAckType[SCUEventDispatchAckType["nack"] = 2] = "nack";
})(SCUEventDispatchAckType = exports.SCUEventDispatchAckType || (exports.SCUEventDispatchAckType = {}));
var SCUEventDispatchUnit = /** @class */ (function () {
    function SCUEventDispatchUnit(id, name) {
        this.id = id;
        this.name = name;
    }
    SCUEventDispatchUnit.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new SCUEventDispatchUnit(cerealParse_1.ParseUtils.getString(o, 'id'), cerealParse_1.ParseUtils.getString(o, 'name')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid SCUEventDispatchUnit model: " + e.message);
        }
    };
    return SCUEventDispatchUnit;
}());
exports.SCUEventDispatchUnit = SCUEventDispatchUnit;
var SCUEventDispatch = /** @class */ (function (_super) {
    __extends(SCUEventDispatch, _super);
    function SCUEventDispatch(id, scuId, ts, level, job, ackTime, status, unit) {
        var _this = _super.call(this, id, scuId, ts, level, SCUEventType.dispatch) || this;
        _this.job = job;
        _this.ackTime = ackTime;
        _this.status = status;
        _this.unit = unit;
        return _this;
    }
    SCUEventDispatch.parseEvent = function (id, scuId, ts, level, o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new SCUEventDispatch(id, scuId, ts, level, cerealParse_1.ParseUtils.getSubobject(o, 'job', SCUEventDispatchJob.parse), cerealParse_1.ParseUtils.getUNIXTimestampDateOrNull(o, 'ackTime'), cerealParse_1.ParseUtils.getEnum(o, 'status', SCUEventDispatchAckType), cerealParse_1.ParseUtils.getSubobject(o, 'unit', SCUEventDispatchUnit.parse)));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid SCUEventDispatch Model: " + e.message);
        }
    };
    return SCUEventDispatch;
}(SCUEvent));
exports.SCUEventDispatch = SCUEventDispatch;
var SCUEventLight = /** @class */ (function (_super) {
    __extends(SCUEventLight, _super);
    function SCUEventLight(id, scuId, ts, level, description, cause) {
        var _this = _super.call(this, id, scuId, ts, level, SCUEventType.light) || this;
        _this.description = description;
        _this.cause = cause;
        return _this;
    }
    SCUEventLight.parseEvent = function (id, scuId, ts, level, o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new SCUEventLight(id, scuId, ts, level, cerealParse_1.ParseUtils.getString(o, 'description'), cerealParse_1.ParseUtils.getStringOrNull(o, 'cause')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid SCUEventLight Model: " + e.message);
        }
    };
    return SCUEventLight;
}(SCUEvent));
exports.SCUEventLight = SCUEventLight;
var SCUEventTone = /** @class */ (function (_super) {
    __extends(SCUEventTone, _super);
    function SCUEventTone(id, scuId, ts, level, tone, cause) {
        var _this = _super.call(this, id, scuId, ts, level, SCUEventType.tone) || this;
        _this.tone = tone;
        _this.cause = cause;
        return _this;
    }
    SCUEventTone.parseEvent = function (id, scuId, ts, level, o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new SCUEventTone(id, scuId, ts, level, cerealParse_1.ParseUtils.getString(o, 'tone'), cerealParse_1.ParseUtils.getStringOrNull(o, 'cause')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid SCUEventTone Model: " + e.message);
        }
    };
    return SCUEventTone;
}(SCUEvent));
exports.SCUEventTone = SCUEventTone;
var SCUEventTts = /** @class */ (function (_super) {
    __extends(SCUEventTts, _super);
    function SCUEventTts(id, scuId, ts, level, text, cause) {
        var _this = _super.call(this, id, scuId, ts, level, SCUEventType.tts) || this;
        _this.text = text;
        _this.cause = cause;
        return _this;
    }
    SCUEventTts.parseEvent = function (id, scuId, ts, level, o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new SCUEventTts(id, scuId, ts, level, cerealParse_1.ParseUtils.getString(o, 'text'), cerealParse_1.ParseUtils.getStringOrNull(o, 'cause')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid SCUEventTts Model: " + e.message);
        }
    };
    return SCUEventTts;
}(SCUEvent));
exports.SCUEventTts = SCUEventTts;
var SCUEventGPIO = /** @class */ (function (_super) {
    __extends(SCUEventGPIO, _super);
    function SCUEventGPIO(id, scuId, ts, level, cause, on, relay, device) {
        var _this = _super.call(this, id, scuId, ts, level, SCUEventType.gpio) || this;
        _this.cause = cause;
        _this.on = on;
        _this.relay = relay;
        _this.device = device;
        return _this;
    }
    SCUEventGPIO.parseEvent = function (id, scuId, ts, level, o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new SCUEventGPIO(id, scuId, ts, level, cerealParse_1.ParseUtils.getStringOrNull(o, 'cause'), cerealParse_1.ParseUtils.getBoolean(o, 'on'), cerealParse_1.ParseUtils.getNumber(o, 'relay'), cerealParse_1.ParseUtils.getString(o, 'device')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid SCUEventGPIO Model: " + e.message);
        }
    };
    return SCUEventGPIO;
}(SCUEvent));
exports.SCUEventGPIO = SCUEventGPIO;
var SCUEventPrint = /** @class */ (function (_super) {
    __extends(SCUEventPrint, _super);
    function SCUEventPrint(id, scuId, ts, level, job, printer, copies) {
        var _this = _super.call(this, id, scuId, ts, level, SCUEventType.print) || this;
        _this.job = job;
        _this.printer = printer;
        _this.copies = copies;
        return _this;
    }
    SCUEventPrint.parseEvent = function (id, scuId, ts, level, o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new SCUEventPrint(id, scuId, ts, level, cerealParse_1.ParseUtils.getSubobject(o, 'job', SCUEventDispatchJob.parse), cerealParse_1.ParseUtils.getString(o, 'printer'), cerealParse_1.ParseUtils.getNumber(o, 'copies')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid SCUEventPrint Model: " + e.message);
        }
    };
    return SCUEventPrint;
}(SCUEvent));
exports.SCUEventPrint = SCUEventPrint;
var SCUEventGenericInfo = /** @class */ (function (_super) {
    __extends(SCUEventGenericInfo, _super);
    function SCUEventGenericInfo(id, scuId, ts, level, message) {
        var _this = _super.call(this, id, scuId, ts, level, SCUEventType.genericInfo) || this;
        _this.message = message;
        return _this;
    }
    SCUEventGenericInfo.parseEvent = function (id, scuId, ts, level, o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new SCUEventGenericInfo(id, scuId, ts, level, cerealParse_1.ParseUtils.getString(o, 'message')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid SCUEventGenericInfo Model: " + e.message);
        }
    };
    return SCUEventGenericInfo;
}(SCUEvent));
exports.SCUEventGenericInfo = SCUEventGenericInfo;
var SCUEventBooted = /** @class */ (function (_super) {
    __extends(SCUEventBooted, _super);
    function SCUEventBooted(id, scuId, ts, level) {
        return _super.call(this, id, scuId, ts, level, SCUEventType.booted) || this;
    }
    SCUEventBooted.parseEvent = function (id, scuId, ts, level) {
        return cerealParse_1.ParseUtils.parseSuccess(new SCUEventBooted(id, scuId, ts, level));
    };
    return SCUEventBooted;
}(SCUEvent));
exports.SCUEventBooted = SCUEventBooted;
var SCUEventPrimaryNetwork = /** @class */ (function (_super) {
    __extends(SCUEventPrimaryNetwork, _super);
    function SCUEventPrimaryNetwork(id, scuId, ts, level) {
        return _super.call(this, id, scuId, ts, level, SCUEventType.primaryNetwork) || this;
    }
    SCUEventPrimaryNetwork.parseEvent = function (id, scuId, ts, level) {
        return cerealParse_1.ParseUtils.parseSuccess(new SCUEventPrimaryNetwork(id, scuId, ts, level));
    };
    return SCUEventPrimaryNetwork;
}(SCUEvent));
exports.SCUEventPrimaryNetwork = SCUEventPrimaryNetwork;
var SCUEventBackupNetwork = /** @class */ (function (_super) {
    __extends(SCUEventBackupNetwork, _super);
    function SCUEventBackupNetwork(id, scuId, ts, level) {
        return _super.call(this, id, scuId, ts, level, SCUEventType.backupNetwork) || this;
    }
    SCUEventBackupNetwork.parseEvent = function (id, scuId, ts, level) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new SCUEventBackupNetwork(id, scuId, ts, level));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid SCUEventBackupNetwork Model: " + e.message);
        }
    };
    return SCUEventBackupNetwork;
}(SCUEvent));
exports.SCUEventBackupNetwork = SCUEventBackupNetwork;
var SCUEventNetworkUp = /** @class */ (function (_super) {
    __extends(SCUEventNetworkUp, _super);
    function SCUEventNetworkUp(id, scuId, ts, level, networkType) {
        var _this = _super.call(this, id, scuId, ts, level, SCUEventType.networkUp) || this;
        _this.networkType = networkType;
        return _this;
    }
    SCUEventNetworkUp.parseEvent = function (id, scuId, ts, level, o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new SCUEventNetworkUp(id, scuId, ts, level, cerealParse_1.ParseUtils.getEnum(o, 'networkType', SCUNetworkType)));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid SCUEventNetworkUp Model: " + e.message);
        }
    };
    return SCUEventNetworkUp;
}(SCUEvent));
exports.SCUEventNetworkUp = SCUEventNetworkUp;
var SCUEventNetworkDown = /** @class */ (function (_super) {
    __extends(SCUEventNetworkDown, _super);
    function SCUEventNetworkDown(id, scuId, ts, level, networkType) {
        var _this = _super.call(this, id, scuId, ts, level, SCUEventType.networkDown) || this;
        _this.networkType = networkType;
        return _this;
    }
    SCUEventNetworkDown.parseEvent = function (id, scuId, ts, level, o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new SCUEventNetworkDown(id, scuId, ts, level, cerealParse_1.ParseUtils.getEnum(o, 'networkType', SCUNetworkType)));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid SCUEventNetworkDown Model: " + e.message);
        }
    };
    return SCUEventNetworkDown;
}(SCUEvent));
exports.SCUEventNetworkDown = SCUEventNetworkDown;
var SCUEventDeviceType;
(function (SCUEventDeviceType) {
    SCUEventDeviceType[SCUEventDeviceType["hueBridge"] = 0] = "hueBridge";
    SCUEventDeviceType[SCUEventDeviceType["bryxLedController"] = 1] = "bryxLedController";
    SCUEventDeviceType[SCUEventDeviceType["denonMixer"] = 2] = "denonMixer";
    SCUEventDeviceType[SCUEventDeviceType["bryxSpeakerMatrix"] = 3] = "bryxSpeakerMatrix";
    SCUEventDeviceType[SCUEventDeviceType["evokGpio"] = 4] = "evokGpio";
})(SCUEventDeviceType = exports.SCUEventDeviceType || (exports.SCUEventDeviceType = {}));
var SCUEventDeviceConnectionRestored = /** @class */ (function (_super) {
    __extends(SCUEventDeviceConnectionRestored, _super);
    function SCUEventDeviceConnectionRestored(id, scuId, ts, level, deviceId, deviceType) {
        var _this = _super.call(this, id, scuId, ts, level, SCUEventType.deviceConnectionRestored) || this;
        _this.deviceId = deviceId;
        _this.deviceType = deviceType;
        return _this;
    }
    SCUEventDeviceConnectionRestored.parseEvent = function (id, scuId, ts, level, o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new SCUEventDeviceConnectionRestored(id, scuId, ts, level, cerealParse_1.ParseUtils.getString(o, 'deviceId'), cerealParse_1.ParseUtils.getEnum(o, 'deviceType', SCUEventDeviceType)));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid SCUEventDeviceConnectionRestored Model: " + e.message);
        }
    };
    return SCUEventDeviceConnectionRestored;
}(SCUEvent));
exports.SCUEventDeviceConnectionRestored = SCUEventDeviceConnectionRestored;
var SCUEventGenericError = /** @class */ (function (_super) {
    __extends(SCUEventGenericError, _super);
    function SCUEventGenericError(id, scuId, ts, level, message) {
        var _this = _super.call(this, id, scuId, ts, level, SCUEventType.genericError) || this;
        _this.message = message;
        return _this;
    }
    SCUEventGenericError.parseEvent = function (id, scuId, ts, level, o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new SCUEventGenericError(id, scuId, ts, level, cerealParse_1.ParseUtils.getString(o, 'message')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid SCUEventGenericError Model: " + e.message);
        }
    };
    return SCUEventGenericError;
}(SCUEvent));
exports.SCUEventGenericError = SCUEventGenericError;
var SCUEventAudioFailure = /** @class */ (function (_super) {
    __extends(SCUEventAudioFailure, _super);
    function SCUEventAudioFailure(id, scuId, ts, level, message) {
        var _this = _super.call(this, id, scuId, ts, level, SCUEventType.audioFailure) || this;
        _this.message = message;
        return _this;
    }
    SCUEventAudioFailure.parseEvent = function (id, scuId, ts, level, o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new SCUEventAudioFailure(id, scuId, ts, level, cerealParse_1.ParseUtils.getString(o, 'message')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid SCUEventAudioFailure Model: " + e.message);
        }
    };
    return SCUEventAudioFailure;
}(SCUEvent));
exports.SCUEventAudioFailure = SCUEventAudioFailure;
var SCUEventTimeOutOfSync = /** @class */ (function (_super) {
    __extends(SCUEventTimeOutOfSync, _super);
    function SCUEventTimeOutOfSync(id, scuId, ts, level) {
        return _super.call(this, id, scuId, ts, level, SCUEventType.timeOutOfSync) || this;
    }
    SCUEventTimeOutOfSync.parseEvent = function (id, scuId, ts, level) {
        return cerealParse_1.ParseUtils.parseSuccess(new SCUEventTimeOutOfSync(id, scuId, ts, level));
    };
    return SCUEventTimeOutOfSync;
}(SCUEvent));
exports.SCUEventTimeOutOfSync = SCUEventTimeOutOfSync;
var SCUEventHueAuthFailure = /** @class */ (function (_super) {
    __extends(SCUEventHueAuthFailure, _super);
    function SCUEventHueAuthFailure(id, scuId, ts, level, message) {
        var _this = _super.call(this, id, scuId, ts, level, SCUEventType.hueAuthFailure) || this;
        _this.message = message;
        return _this;
    }
    SCUEventHueAuthFailure.parseEvent = function (id, scuId, ts, level, o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new SCUEventHueAuthFailure(id, scuId, ts, level, cerealParse_1.ParseUtils.getString(o, 'message')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid SCUEventHueAuthFailure Model: " + e.message);
        }
    };
    return SCUEventHueAuthFailure;
}(SCUEvent));
exports.SCUEventHueAuthFailure = SCUEventHueAuthFailure;
var SCUEventAudioRecorderFailure = /** @class */ (function (_super) {
    __extends(SCUEventAudioRecorderFailure, _super);
    function SCUEventAudioRecorderFailure(id, scuId, ts, level, message) {
        var _this = _super.call(this, id, scuId, ts, level, SCUEventType.audioRecorderFailure) || this;
        _this.message = message;
        return _this;
    }
    SCUEventAudioRecorderFailure.parseEvent = function (id, scuId, ts, level, o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new SCUEventAudioRecorderFailure(id, scuId, ts, level, cerealParse_1.ParseUtils.getString(o, 'message')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid SCUEventAudioRecorderFailure Model: " + e.message);
        }
    };
    return SCUEventAudioRecorderFailure;
}(SCUEvent));
exports.SCUEventAudioRecorderFailure = SCUEventAudioRecorderFailure;
var SCUEventTtsFailure = /** @class */ (function (_super) {
    __extends(SCUEventTtsFailure, _super);
    function SCUEventTtsFailure(id, scuId, ts, level, message) {
        var _this = _super.call(this, id, scuId, ts, level, SCUEventType.ttsFailure) || this;
        _this.message = message;
        return _this;
    }
    SCUEventTtsFailure.parseEvent = function (id, scuId, ts, level, o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new SCUEventTtsFailure(id, scuId, ts, level, cerealParse_1.ParseUtils.getString(o, 'message')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid SCUEventTtsFailure Model: " + e.message);
        }
    };
    return SCUEventTtsFailure;
}(SCUEvent));
exports.SCUEventTtsFailure = SCUEventTtsFailure;
var SCUEventLowDiskSpace = /** @class */ (function (_super) {
    __extends(SCUEventLowDiskSpace, _super);
    function SCUEventLowDiskSpace(id, scuId, ts, level, percent) {
        var _this = _super.call(this, id, scuId, ts, level, SCUEventType.lowDiskSpace) || this;
        _this.percent = percent;
        return _this;
    }
    SCUEventLowDiskSpace.parseEvent = function (id, scuId, ts, level, o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new SCUEventLowDiskSpace(id, scuId, ts, level, cerealParse_1.ParseUtils.getNumber(o, 'percent')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid SCUEventLowDiskSpace Model: " + e.message);
        }
    };
    return SCUEventLowDiskSpace;
}(SCUEvent));
exports.SCUEventLowDiskSpace = SCUEventLowDiskSpace;
var SCUEventPrintingFailure = /** @class */ (function (_super) {
    __extends(SCUEventPrintingFailure, _super);
    function SCUEventPrintingFailure(id, scuId, ts, level, job, printer) {
        var _this = _super.call(this, id, scuId, ts, level, SCUEventType.printingFailure) || this;
        _this.job = job;
        _this.printer = printer;
        return _this;
    }
    SCUEventPrintingFailure.parseEvent = function (id, scuId, ts, level, o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new SCUEventPrintingFailure(id, scuId, ts, level, cerealParse_1.ParseUtils.getSubobject(o, 'job', SCUEventDispatchJob.parse), cerealParse_1.ParseUtils.getString(o, 'printer')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid SCUEventPrintingFailure Model: " + e.message);
        }
    };
    return SCUEventPrintingFailure;
}(SCUEvent));
exports.SCUEventPrintingFailure = SCUEventPrintingFailure;
var SCUEventDeviceConnectionLost = /** @class */ (function (_super) {
    __extends(SCUEventDeviceConnectionLost, _super);
    function SCUEventDeviceConnectionLost(id, scuId, ts, level, deviceId, deviceType) {
        var _this = _super.call(this, id, scuId, ts, level, SCUEventType.deviceConnectionLost) || this;
        _this.deviceId = deviceId;
        _this.deviceType = deviceType;
        return _this;
    }
    SCUEventDeviceConnectionLost.parseEvent = function (id, scuId, ts, level, o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new SCUEventDeviceConnectionLost(id, scuId, ts, level, cerealParse_1.ParseUtils.getString(o, 'deviceId'), cerealParse_1.ParseUtils.getEnum(o, 'deviceType', SCUEventDeviceType)));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid SCUEventDeviceConnectionLost Model: " + e.message);
        }
    };
    return SCUEventDeviceConnectionLost;
}(SCUEvent));
exports.SCUEventDeviceConnectionLost = SCUEventDeviceConnectionLost;
//# sourceMappingURL=scuEvent.js.map